import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/earlyEntries';

import HorseRacingEarlyEntriesList from '../components/HorseRacingEarlyEntriesList';

@standardAsyncConnect([
  {
    dispatch: () => load(),
    preventResolve: ({state}) => isLoading(state),
    state: state => ({earlyEntries: state.horseRacing.earlyEntries.earlyEntries})
  }
])
@catchLifeCycleErrors
export default class HorseRacingEarlyEntriesContainer extends Component {
  static propTypes = {
    earlyEntries: PropTypes.arrayOf(PropTypes.object),
    dispatch: PropTypes.func.isRequired
  };

  render() {
    const {
      earlyEntries = []
    } = this.props;

    return (
      <div className="early-entries-container">
        <h1 className="page-main-title">Early Entries</h1>
        <HorseRacingEarlyEntriesList earlyEntries={earlyEntries}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingEarlyEntriesContainer.js